import React, {useContext, useEffect, useReducer, useState} from 'react';
import Segment from "semantic-ui-react/dist/commonjs/elements/Segment";
import {Button, Form, Header, Icon, Loader, Menu} from "semantic-ui-react";
import {toast, ToastContainer} from "react-toastify";
import {UserRoleContext} from "../../Main";
import axios from "axios";
import CourseForm from "./CourseForm";
import Table from "semantic-ui-react/dist/commonjs/collections/Table";
import Popup from "semantic-ui-react/dist/commonjs/modules/Popup";
import SearchTableData from "../Utilities/SearchTableData";
import ReactExport from 'react-data-export';
import PaginationFront from "../Utilities/PaginationFront";

const reducer = (state, action)=>{
    switch (action.type) {
        case 'currentId':
            return {...state, currentId: action.payload};
        case 'openTable':
            return {...state, openTable: action.payload};
        case 'loader':
            return {...state, loader: action.payload};
        case 'organizer':
            return {...state, organizer: action.payload};
        case 'organizers':
            return {...state, organizers: action.payload};
        case 'courses':
            return {...state, courses: action.payload};
        case 'course':
            return {...state, course: action.payload};
        case 'coursesData':
            return {...state, coursesData: action.payload };
        case 'data':
            return {...state, data: action.payload};
        case 'results':
            return {...state, results: action.payload};
        case 'postsPerPage':
            return {...state, postsPerPage: action.payload};
        case 'currentPosts':
            return {...state, currentPosts: action.payload};
        default:
            return state;
    }
};


const AllCourses = () => {
    const [activePage, setActivePage] = useState(1);
    const [state, dispatch] = useReducer(reducer,{
        currentId: null,
        openTable: false,
        loader: false,
        organizer: '',
        organizers: [],
        courses: [],
        coursesData: [],
        course: '',
        data:[],
        results:[],
        postsPerPage: 20,
        currentPosts: [],
    } );
    const {activeRole} = useContext(UserRoleContext);
    const { ExcelFile } = ReactExport;
    const { ExcelSheet } = ReactExport.ExcelFile;
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);

    const indexOfLastPost = activePage * state.postsPerPage;
    const indexOfFirstPost = indexOfLastPost - state.postsPerPage;
    const currentPosts = getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

    const columns = [
        { title: 'Naziv predmeta (B/H/S)', width: { wpx: 700 } },
        { title: 'Napomena', width: { wpx: 150 } },
    ];

    if (activeRole !== "ROLE_ORGANIZER") {
        columns.unshift({ title: 'Organizator', width: { wpx: 400 } });
    }

    const multiDataSet = [
        {
            columns: columns,
            data: state.coursesData,
        }
    ];

    // const multiDataSet = [
    //     {
    //         columns: [
    //             { title: 'Naziv predmeta (B/H/S)', width: { wpx: 700 } },
    //             { title: 'Napomena', width: { wpx: 150 } },
    //         ],
    //         data: state.coursesData,
    //     }
    // ];

    let toggleAddForm = () =>{
        setShowAddForm(!showAddForm)
    };

    let toggleEditForm = () =>{
        setShowEditForm(!showEditForm)
    };

    function getDataToRender() {
        if (state.results.length !== 0) {
            return state.results;
        }
        return state.data;
    }

    const handlePaginationChange = (e, { activePage }) => {
        setActivePage(activePage);
    };

    function getResults(results) {
        dispatch({type: 'results', payload: results});
        setActivePage(1);
        handlePaginationChange({}, { activePage });
    }

    useEffect(() => {
        // activeRole === "ROLE_ORGANIZER" ? getCourses() : getOrganizers();
        if (activeRole === "ROLE_ORGANIZER") {
            getCourses()
        }
        else if(activeRole === "ROLE_ADMIN" || activeRole === "ROLE_MINISTRY") {
            getOrganizers();
            getCoursesAll();
        }
    },[activeRole]);

    function deleteCourse(id){
        setCurrentId(id);
        dispatch({type: 'loader', payload: true});
        axios.delete(`/course/delete/${id}`,).then(
            (res) => {
                activeRole === "ROLE_ORGANIZER" ? getCourses() : getCoursesForAdmin(state.organizer);
                toast('Uspješno ste izbrisali predmet!');
                setCurrentId(null);
                dispatch({type: 'loader', payload: false});
            }).catch((err) => {
                if (err.response.data.message === 'This course has existing course study programs!') {
                    toast('Predmet se nalazi na nekom nastavnom programu i nije dozvoljeno brisanje.');
                    setCurrentId(null);
                } else {
                    toast('Došlo je do greške! Brisanje predmeta nije uspjelo.');
                    setCurrentId(null);
                }
            dispatch({type: 'loader', payload: false});
            console.log('err', err)
        });
    }

    function getOrganizers(){
        dispatch({type: 'loader', payload: true});
        axios.get('/organizer/all',).then(
            (res) => {
                let organizers = res.data.map((el)=>({...el, key: el.id, text:el.name, value: el.id}));
                dispatch({type: 'organizers', payload: organizers});
                dispatch({type: 'loader', payload: false});
            }).catch((err) => {
            console.log('err', err)
        });
    }

    function handleInputChange(event, { name, value }) {
        dispatch({type: name, payload: value});
        if(name === 'organizer' && value){
            dispatch({type: 'openTable', payload: true});
            getCoursesForAdmin(value)
        }
        if(name === 'organizer' && !value){
            dispatch({type: 'openTable', payload: true});
            getCoursesAll()
        }
    }

    function getCoursesForAdmin(id){
        setCurrentId(id);
        setCurrentIdOrganizer(id);
        dispatch({type: 'loader', payload: true});
        dispatch({type: 'openTable', payload: true});
        axios.get(`/course/by-organizer-id/${id}`,).then(
            (res) => {
                let courses = res.data;
                dispatch({type: 'courses', payload: courses});
                dispatch({type: 'data', payload: courses});
                let coursesData = res.data.map(el => ([
                    { value: el.organizer.name },
                    { value: el.nameBosnian + '/' + el.nameCroatian + '/' + el.nameSerbian },
                    { value: el.comment ? el.comment : '' },
                ]));
                dispatch({type: 'coursesData', payload: coursesData});
                dispatch({type: 'loader', payload: false});
                setCurrentId(null);
            }).catch((err) => {
            console.log('err', err)
        });
    }

    function getCourses(){
        dispatch({type: 'loader', payload: true});
        axios.get('/course/by-organizer',).then(
            (res) => {
                let courses = res.data;
                dispatch({type: 'courses', payload: courses});
                dispatch({type: 'data', payload: courses});
                let coursesData = res.data.map(el => ([
                    { value: el.nameBosnian + '/' + el.nameCroatian + '/' + el.nameSerbian },
                    { value: el.comment ? el.comment : '' },
                ]));
                dispatch({type: 'coursesData', payload: coursesData});
                dispatch({type: 'loader', payload: false});
            }).catch((err) => {
            console.log('err', err)
        });
    }

    function getCoursesAll(){
        dispatch({type: 'loader', payload: true});
        axios.get('/course/all',).then(
            (res) => {
                let courses = res.data;
                dispatch({type: 'courses', payload: courses});
                dispatch({type: 'data', payload: courses});
                let coursesData = res.data.map(el => ([
                    { value: el.organizer.name },
                    { value: el.nameBosnian + '/' + el.nameCroatian + '/' + el.nameSerbian },
                    { value: el.comment ? el.comment : '' },
                ]));
                dispatch({type: 'coursesData', payload: coursesData});
                dispatch({type: 'loader', payload: false});
            }).catch((err) => {
            console.log('err', err)
        });
    }

    function setCurrentIdOrganizer(value){
        dispatch({type: 'organizer', payload: value});
    }

    function setCurrentId(value){
        dispatch({type: 'currentId', payload: value});
    }

    return (
        <div>
            <Segment.Group >
                <Segment className={'customPadding'} clearing color={"teal"}>

                    <Menu  secondary size={"tiny"} compact stackable floated={"right"} fluid>

                        <Menu.Item >
                            <Header as={'h3'} floated={"left"}>Spisak predmeta
                                <span><Icon/></span>
                            </Header>
                        </Menu.Item>
                        <Menu.Menu position={'right'}>
                            {(!showEditForm) && activeRole !== "ROLE_MINISTRY" && <Menu.Item>
                                <Button icon labelPosition='left' size="mini" basic color="black" onClick={toggleAddForm}>
                                    <Icon name='add' color={"teal"}/>
                                    Kreiraj predmet
                                </Button>
                            </Menu.Item>}
                             <Menu.Item>
                                <ExcelFile filename="Spisak predmeta" element={<Button icon labelPosition='left' size="tiny" basic color="black">
                                    <Icon name='file excel outline' color={"green"}/>
                                    Preuzmi spisak
                                </Button>}>
                                    <ExcelSheet dataSet={multiDataSet} name="Predmeti" />
                                </ExcelFile>
                            </Menu.Item>
                            <Menu.Item>
                                <span>
                                    <Button floated={"right"} icon size={"mini"} basic onClick={() => window.history.go(-1)}>
                                        <Icon name='arrow left'/>
                                    </Button>
                                    <Icon/>
                                </span>
                            </Menu.Item>
                        </Menu.Menu>

                    </Menu>

                </Segment>
                {showEditForm &&
                <Segment>
                    <CourseForm edit toggleEditForm={toggleEditForm} getCourses={getCourses} getCoursesForAdmin={getCoursesForAdmin} setCurrentIdOrganizer={setCurrentIdOrganizer} course={state.course}/>
                </Segment>}

                {(showAddForm) &&
                <Segment>
                    <CourseForm add toggleEditForm={toggleAddForm} getCourses={getCourses} getCoursesForAdmin={getCoursesForAdmin} setCurrentIdOrganizer={setCurrentIdOrganizer}/>
                </Segment>}
                {(activeRole === "ROLE_ADMIN" || activeRole === "ROLE_MINISTRY") && <Segment><Form size={'small'}>
                    <Form.Group widths="3">
                        <Form.Field>
                            <label>Organizator</label>
                            <Form.Dropdown
                                placeholder="Odaberite organizatora"
                                value={state.organizer}
                                onChange={handleInputChange}
                                name="organizer"
                                options={state.organizers}
                                search
                                fluid
                                selection
                                clearable
                            />
                        </Form.Field>
                    </Form.Group>
                </Form></Segment>}

                {/*{((activeRole === "ROLE_ADMIN" && state.openTable) || (activeRole === "ROLE_MINISTRY" && state.openTable) || activeRole === "ROLE_ORGANIZER") &&*/}
                <Segment>
                    {state.loader ?
                        <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        :
                        currentPosts.length ?
                            <Table celled size={'small'}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={activeRole !== "ROLE_ORGANIZER" ? 11 : 9} >
                                            <div style={{ paddingLeft: '0px' }}>
                                                <SearchTableData data={state.data} getResults={getResults} filterItem={['nameBosnian','nameCroatian', 'nameSerbian', 'comment']} />
                                            </div>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>

                                        <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                        {activeRole !== "ROLE_ORGANIZER"  &&<Table.HeaderCell colSpan={2} >Organizator</Table.HeaderCell>}
                                        <Table.HeaderCell colSpan={3}>Naziv predmeta (B / H / S)</Table.HeaderCell>
                                        {/*<Table.HeaderCell>Naziv predmeta na hrvatskom jeziku</Table.HeaderCell>*/}
                                        {/*<Table.HeaderCell>Naziv predmeta na srpskom jeziku</Table.HeaderCell>*/}
                                        <Table.HeaderCell width={3}>Napomena</Table.HeaderCell>
                                        {activeRole !== "ROLE_MINISTRY" && <Table.HeaderCell width={1} />}
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {
                                        currentPosts.map((el, index) =>
                                        // state.courses.map((el, index)=>
                                            (<Table.Row>
                                                <Table.Cell width={1}>{(index + 1) + ((activePage - 1) * state.postsPerPage)}.</Table.Cell>
                                                {activeRole !== "ROLE_ORGANIZER"  &&<Table.Cell colSpan={2}>{el.organizer.name}</Table.Cell>}
                                                <Table.Cell colSpan={3}>{el.nameBosnian} / {el.nameCroatian} / {el.nameSerbian}</Table.Cell>
                                                {/*<Table.Cell>{el.nameCroatian}</Table.Cell>*/}
                                                {/*<Table.Cell>{el.nameSerbian}</Table.Cell>*/}
                                                <Table.Cell width={3}>{el.comment}</Table.Cell>
                                                {activeRole !== "ROLE_MINISTRY" && <Table.Cell width={1} verticalAlign="middle" textAlign="center">
                                                    <Popup size={"small"} content='Izmijeni predmet' trigger={
                                                        <Button icon size={"mini"} basic color={"grey"}  onClick={() => {window.scrollTo(0, 0);setShowEditForm(true); dispatch({type: 'course', payload: el})}}>
                                                            <Icon name='pencil' color={"teal"} />
                                                        </Button>} />
                                                    <Popup size={"small"} content='Obriši predmet' trigger={ <Button icon size={"mini"} basic color={"grey"}
                                                               disabled={state.currentId && el.id !== state.currentId } onClick={() => {deleteCourse(el.id)}}>
                                                        <Icon name='trash alternate outline' color={"red"} />
                                                    </Button>} />
                                                </Table.Cell>}
                                            </Table.Row>)
                                        )
                                    }
                                </Table.Body>

                                <Table.Footer>
                                    {/*<Table.Row>*/}
                                    {/*    <Table.HeaderCell colSpan='14' textAlign='center'>*/}
                                    {/*        <Menu  pagination>*/}
                                    {/*            <Menu.Item as='a' icon>*/}
                                    {/*                <Icon name='chevron left' />*/}
                                    {/*            </Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>1</Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>2</Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>3</Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>4</Menu.Item>*/}
                                    {/*            <Menu.Item as='a' icon>*/}
                                    {/*                <Icon name='chevron right' />*/}
                                    {/*            </Menu.Item>*/}
                                    {/*        </Menu>*/}
                                    {/*    </Table.HeaderCell>*/}
                                    {/*</Table.Row>*/}
                                </Table.Footer>
                            </Table>: <div>Nema unesenih podataka o predmetima.</div>}
                    {currentPosts.length >0 && <PaginationFront postsPerPage={state.postsPerPage} totalPosts={getDataToRender().length} paginate={handlePaginationChange} activePage={activePage} />}
                </Segment>

            </Segment.Group>
            <ToastContainer  />

        </div>
    );
};

export default AllCourses;
